module.exports = __webpack_public_path__ + "img/r_figure_02.ac1a3048.png";